import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from "axios"

export interface EditUserContactRequest extends Partial<AxiosRequestConfig> {
  data: {
    userId: number
    emailId: string
    mobileno1: string
    dialerCode: string
  }
}

export interface EditUserContactResponse extends AxiosResponse {
  data: {
    apiStatus: string
    message?: string
    errorCode?: number
    errorMessage?: string
  }
}

export function updateUserDashboardApi(
  { data, ...config }: EditUserContactRequest,
  axiosInstance: AxiosInstance,
): Promise<EditUserContactResponse> {
  return axiosInstance({
    data,
    method: "put",
    url: "newadmin/user-account/contact",
    ...config,
  }) as Promise<EditUserContactResponse>
}
